import {
  Accordion,
  AccordionContent,
  AccordionItem,
  AccordionTrigger,
} from "@/components/ui/accordion";

import { Paragraph } from "@/components/ui/typography/Paragraph";

interface PatientsItemProps {
  Icon: React.ComponentType<React.SVGProps<SVGSVGElement>>;
  label: string;
  children: React.ReactNode;
  open?: boolean;
  onOpenChange?: (open: boolean) => void;
}

export const AccordionSidebarItem = ({
  Icon,
  label,
  children,
  open,
  onOpenChange,
}: PatientsItemProps) => {
  return (
    <Accordion
      type="single"
      collapsible
      value={open ? "item-1" : ""}
      onValueChange={(value) => onOpenChange?.(value === "item-1")}
    >
      <AccordionItem value="item-1">
        <AccordionTrigger
          className={`flex items-center space-x-2 p-2 rounded-md min-w-full`}
        >
          <div className="flex gap-2">
            <Icon className="text-black" />
            <Paragraph color="text-black">{label}</Paragraph>
          </div>
        </AccordionTrigger>
        <AccordionContent>
          <div className="flex gap-2 ms-2">
            <div className="inline-block min-h-full w-0.5 self-stretch bg-neutral-100"></div>
            <div className="flex flex-col gap-2 w-full my-1">{children}</div>
          </div>
        </AccordionContent>
      </AccordionItem>
    </Accordion>
  );
};
